var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-row',{staticClass:"layout"},_vm._l((7),function(item,index){return _c('van-col',{key:index,attrs:{"span":"4"}},[_c('div',{staticClass:"tit"},[_vm._v("冯提莫")]),_c('div',{staticClass:"desc"},[_vm._v("2016级（12）班")])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }